import service from '@/utils/server';

const modName='/report/carrierAging/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};
//初始化页面对象
export const initPage = data => {
  return service({
    url: modName + 'initPage',
    method: 'post',
    data
  });
};

//初始化更新对象
export const initUpdate = data => {
  return service({
    url: modName + 'initUpdate/' + data,
    method: 'post',
    data
  });
};
//导出excel
export const exportData = data => {
  let config = {
    timeout: 500000, // 请求超时时间
    responseType: "blob"
  };
  return service({
    ...config,
    url: modName + 'export',
    method: 'post',
    data
  });
};




// WEBPACK FOOTER //
// ./src/page/report/carrierAging/api/index.js